import { MIN_HORIZONTAL_SCROLLBAR_WIDTH, MIN_VERTICAL_SCROLLBAR_WIDTH } from "../../settings.ts";

export function getVerticalScrollbarY(scrollY: number, allTracksHeight: number, canvasHeight: number) {
  const divisor = allTracksHeight - canvasHeight;
  if (divisor === 0 || allTracksHeight === 0) {
    return 0;
  }
  return (scrollY / divisor) * (canvasHeight - getVerticalScrollbarHeight(allTracksHeight, canvasHeight));
}

export function getHorizontalScrollbarX(scrollX: number, maxWidth: number, canvasWidth: number) {
  const divisor = maxWidth - canvasWidth;
  if (divisor === 0) {
    return 0;
  }
  return (scrollX / divisor) * (canvasWidth - getHorizontalScrollbarWidth(maxWidth, canvasWidth));
}

export function getVerticalScrollbarHeight(allTracksHeight: number, canvasHeight: number) {
  if (allTracksHeight === 0) {
    return MIN_VERTICAL_SCROLLBAR_WIDTH;
  }
  return Math.max(MIN_VERTICAL_SCROLLBAR_WIDTH, (canvasHeight / allTracksHeight) * canvasHeight);
}

export function getHorizontalScrollbarWidth(maxWidth: number, canvasWidth: number) {
  if (maxWidth === 0) {
    return MIN_HORIZONTAL_SCROLLBAR_WIDTH;
  }
  return Math.max(MIN_HORIZONTAL_SCROLLBAR_WIDTH, (canvasWidth / maxWidth) * canvasWidth);
}

export function getCanvasCoordinates(e: MouseEvent | PointerEvent, rect: DOMRect) {
  return {
    x: e.clientX - rect.left,
    y: e.clientY - rect.top,
  };
}

export function isVerticalScrollbarClicked(x: number, canvasWidth: number) {
  if (isNaN(x) || isNaN(canvasWidth)) {
    return false;
  }

  return x >= canvasWidth - 10 && x <= canvasWidth;
}

export function isHorizontalScrollbarClicked(y: number, canvasHeight: number) {
  if (isNaN(y) || isNaN(canvasHeight)) {
    return false;
  }
  return y >= canvasHeight - 10 && y <= canvasHeight;
}
